function Footer() {
  return (
    <footer className="footer">
      <p>© 2025 Florina Panaite</p>
    </footer>
  );
}

export default Footer;
